import { useCallback, useEffect, useState } from "react";
import { listBuddyGuarantees } from "./buddyGuaranteeApi.js";

/**
 * Prompt 140C: one cheap, real `GET .../buddy-guarantees?pageSize=1` pull,
 * read only for its real `networkSummary` block (a live SQL aggregate
 * grouped by source person over ACTIVE edges, computed server-side -
 * BuddyGuaranteeNetworkSummaryDto) - never computed by pulling every real
 * buddy row client-side, which would not scale to thousands/tens of
 * thousands of people. Powers the KPI strip and the distribution chart;
 * combined with the real worker-applications/worker-profiles roster
 * totals (which this endpoint has no visibility into) by
 * computeRosterKpis/buildDistributionBuckets in buddyGuaranteeShared.js.
 */
export function useBuddyNetworkSummary(enabled) {
  const [state, setState] = useState({ status: "idle", summary: null });
  const [reloadToken, setReloadToken] = useState(0);

  useEffect(() => {
    if (!enabled) {
      setState({ status: "idle", summary: null });
      return undefined;
    }

    let cancelled = false;
    setState((previous) => ({ status: "loading", summary: previous.summary }));

    listBuddyGuarantees({ pageSize: 1 })
      .then((data) => {
        if (!cancelled) {
          setState({ status: "ready", summary: data?.networkSummary ?? null });
        }
      })
      .catch(() => {
        if (!cancelled) {
          setState({ status: "error", summary: null });
        }
      });

    return () => {
      cancelled = true;
    };
  }, [enabled, reloadToken]);

  const refetch = useCallback(() => setReloadToken((token) => token + 1), []);

  return { ...state, refetch };
}
